<template>
  <div>
    <el-drawer
      :visible="Visible"
      size="70%"
      title="Transacciones Duplicadas"
      @close="$emit('VisibleFalse', false)"
    >
      <div class="contenedor-Grafico">
        <IEcharts
          class="grafico"
          :option="bar"
          :loading="loading1"
          style="
            width: 900px;
            height: 400px;
            border-radius: 14px;
            margin-top: 4px;
            position: relative;

            background-color: #f3f7fa;
          "
        />
      </div>
      <el-card class="box-card">
        <div class="table-container">
          <el-table
            class="Tabla"
            :data="tableData"
            style="width: 70%"
            v-loading="Loading"
          >
            <el-table-column label="Acciones" prop="Acciones">
              <template slot-scope="scope">
                <el-popover trigger="click" placement="left">
                  <a
                    @click="
                      ($event) =>
                        OpenAnularTransacction(
                          scope.row.rnc_empresa,
                          scope.row.rnc_cliente,
                          scope.row.fecha
                        )
                    "
                    >Anular Transacciones</a
                  >
                  <div slot="reference" class="name-wrapper">
                    <el-tag> <i class="el-icon-more"></i></el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column prop="descripcion" label="Descripcion" width="180">
            </el-table-column>
            <el-table-column prop="fecha" label="Fecha" width="130">
            </el-table-column>
            <el-table-column
              prop="nombre_cliente"
              label="Nombre Cliente"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="status" label="Status" width="130">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.status === 'EMI' ? 'danger' : 'success'"
                >
                  {{ scope.row.status }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="rnc_empresa" label="RNC Empresa" width="130">
            </el-table-column>
            <el-table-column prop="empresa" label="Empresa" width="190">
            </el-table-column>
            <el-table-column prop="rnc_cliente" label="RNC Cliente" width="130">
            </el-table-column>
            <el-table-column
              prop="tipo_comprobante"
              label="Tipo Comprobante"
              width="150"
            >
            </el-table-column>
            <el-table-column prop="monto" label="Monto" width="80">
            </el-table-column>
            <el-table-column prop="usuario" label="Usuario" width="180">
            </el-table-column>
            <el-table-column prop="cantidad" label="Cantidad" width="100">
            </el-table-column>
            <el-table-column prop="tarjetaid" label="Tarjeta Id" width="180">
            </el-table-column>
            <el-table-column
              prop="tarjetahabiente"
              label="Tarjeta Habiente"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="repetidas" label="Repetidas" width="100">
            </el-table-column>
            <el-table-column prop="formapago" label="Forma Pago" width="100">
            </el-table-column>
            <el-table-column prop="producto" label="Producto" width="100">
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage2"
            :page-sizes="[6, 200, 300, 400]"
            :page-size="6"
            layout="sizes, prev, pager, next"
            :total="registrosTotal"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-drawer>

    <el-dialog
      :visible.sync="Isvisible"
      title="Anular Transacciones Duplicadas"
      :close="CloseAnulaAuditoria"
      width="70%"
    >
      <container class="container">
        <el-table
          class="tabl"
          :data="tableData2"
          style="width: 100%"
          v-loading="isLoading"
        >
          <el-table-column width="180" label="SELECCIONAR">
            <template slot-scope="scope">
              <el-checkbox
                :v-model="checked"
                @change="Cheked(scope.row.ncf, scope.row.Fecha)"
                :disabled="
                  scope.row != tableData2[tableData2.length - 1] &&
                  scope.row.Status != 'ANU'
                    ? false
                    : true
                "
              >
                Anular
              </el-checkbox>
            </template>
          </el-table-column>

          <el-table-column width="180" label="FECHA" prop="Fecha">
          </el-table-column>

          <el-table-column width="180" label="NCF" prop="ncf">
          </el-table-column>

          <el-table-column width="180" label="TARJETA" prop="Tarjeta">
          </el-table-column>

          <el-table-column
            width="180"
            label="TARJETAHABIENTE"
            prop="TarjetaHabiente"
          >
          </el-table-column>

          <el-table-column width="180" label="Cliente" prop="rnc_cliente">
          </el-table-column>

          <el-table-column width="180" label="EMPRESA" prop="rnc_empresa">
          </el-table-column>

          <el-table-column width="180" label="MONTO" prop="monto">
          </el-table-column>

          <el-table-column width="180" label="Status" prop="Status">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row === tableData2[0]
                    ? 'success'
                    : scope.row.Status === 'EMI'
                    ? 'danger'
                    : 'warning'
                "
              >
                {{ scope.row.Status }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </container>
      <br />
      <el-button type="primary" @click="AnularTransaccion">
        Anular Transaccion
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  components: {
    IEcharts
  },

  watch: {
    Visible(val) {
      if (val) {
        this.paginaActual = 1;
        this.currentPage2 = 1;
        this.GetData();
        this.GetDataForGraph();
      }
    }
  },

  props: {
    mes: Number,
    year: Number,
    proveedor: Number,
    cliente: Number,
    descripcion: String,
    Visible: {
      Boolean,
      default: false
    }
  },
  data() {
    return {
      loading1: false,
      tableData: [],
      tableData2: [],
      rnc_empresa: String,
      rnc_cliente: String,
      // descripcion:String,
      Isvisible: false,
      isLoading: false,
      Loading: false,
      checked: true,
      Chehcked: [],
      dia: String,
      ncf: String,
      totalDeRegistrosPorPagina: 6,
      paginaActual: 1,
      currentPage2: 1,
      registrosTotal: 0,
      bar: {
        title: {
          text: ""
        },
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [
          {
            name: "Cantidad de Transacciones",
            type: "line",
            data: []
          },
          {
            name: "",
            type: "line",
            data: []
          }
        ]
      }
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.paginaActual = val;
      this.GetData();
      this.currentPage2 = this.paginaActual;
    },
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetData();
    },

    async GetDataForGraph() {
      this.bar.xAxis.data = [];
      this.bar.series[0].data = [];
      this.loading1 = true;

      await this.$http
        .get(
          `/api/tennos/GetDataForGraph?year=${this.year}&month=${this.mes}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}&descripcion=${this.descripcion}`
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            this.bar.xAxis.data.push(element.Dia);
            this.bar.series[0].data.push(element.Cantidad);
          });
        });

      this.loading1 = false;
    },
    async GetData() {
      this.tableData = [];
      this.Loading = true;

      await this.$http
        .get(
          `/api/tennos/GetDetailsForDuplicatedTransaccionsAndComprobanteSaltos?year=${this.year}&month=${this.mes}&Page=${this.paginaActual}&recordsPerPage=${this.totalDeRegistrosPorPagina}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}`
        )
        .then((resp) => {
          this.registrosTotal = resp.data.total;

          resp.data.resultado.forEach((element) => {
            this.tableData.push(element);
          });
          this.Loading = false;
        });
    },
    async OpenAnularTransacction(rnc_empresa, rnc_cliente, fecha) {
      this.rnc_empresa = rnc_empresa;
      this.rnc_cliente = rnc_cliente;
      var fecha2 = new Date(fecha);
      this.dia = fecha2.getDate();
      await this.GetDataAnular();
      this.Chehcked = [];
      this.Isvisible = true;
    },

    async GetDataAnular() {
      this.tableData2 = [];
      this.isLoading = true;
      this.Chehcked = [];

      await this.$http
        .get(`/api/tennos/GetDuplicateTransaccions`, {
          params: {
            rnc_empresa: this.rnc_empresa,
            rnc_cliente: this.rnc_cliente,
            day: this.dia,
            month: this.mes,
            year: this.year
          }
        })
        .then((resp) => {
          resp.data.forEach((element) => {
            this.tableData2.push(element);
            this.tableData2[0].primera = true;
          });
          this.isLoading = false;
        });
    },

    CloseAnulaAuditoria() {
      this.tableData2 = [];
      this.Isvisible = false;
      this.Chehcked = [];
    },
    Cheked(ncf, fecha) {
      if (this.Chehcked.find((x) => x.ncf === ncf)) {
        var index = this.Chehcked.indexOf(ncf);
        this.Chehcked.splice(index, 1);
      } else {
        this.Chehcked.push({
          ncf,
          fecha
        });
      }
    },

    AnularTransaccion() {
      if (this.Chehcked.length > 0) {
        this.Chehcked.forEach((element) => {
          this.UpdateChececk(element.ncf, element.fecha);
        });
      }
    },

    async UpdateChececk(element, fecha) {
      await this.$http
        .post(
          `/api/tennos/UpdateDuplicateTransaccions?ncf=${element}&rnc_cliente=${this.rnc_cliente}&rnc_empresa=${this.rnc_empresa}&fecha=${fecha}`
        )
        .then((resp) => {
          if (resp.data > 0 && resp.data != 500) {
            this.$message({
              message: "Transacciones Anuladas con exito",
              type: "success"
            });
            this.GetData();
          } else {
            this.$message(
              "Error al intentar anular las transacciones favor hablar con TI"
            );
          }
        });
      this.tableData2 = [];
      this.Chehcked = [];
      await this.GetDataAnular();
    }
  }
};
</script>

<style scoped>
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Tabla {
  margin: 0 auto;
  /* padding-left: 200px; */
}
.grafico {
  margin: 0 auto;
}
.contenedor-Grafico {
  width: 950px;
  height: 380px;
  margin-top: 40px;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
  /* margin: 10 auto; */
}
.table-container {
  margin: 0 auto;
}
.pagination {
  /* margin:0 auto; */
  margin-left: 116.283px;
}
.box-card {
  margin-top: 3rem;
  margin-left: 90px;
  margin-right: 90px;
}
</style>
